import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Tile, TileHeader, TileComment } from '../common/Tile';
import { List, ListItem } from '@bootstraplabs/bsw-common-react';
import { thousandSeparator } from '../../utils/utils';
function displayCap(cap) {
    if (typeof cap === 'number') {
        return "$" + thousandSeparator(cap) + " cap";
    }
    return 'Uncapped';
}
function displayDiscount(discount) {
    return discount + "% discount";
}
export function SafesTile(props) {
    var label = function (raised) { return "$" + thousandSeparator(raised); };
    var terms = function (cap, discount) {
        return [displayCap(cap), displayDiscount(discount)].join(' — ');
    };
    if (props.data.length === 0) {
        return (_jsx(_Fragment, { children: _jsxs(Tile, { children: [_jsx(TileHeader, { children: "SAFEs" }, void 0),
                    _jsx(TileComment, { children: "There are no SAFEs" }, void 0),
                    _jsx(List, { children: _jsx(ListItem, { primary: "Create SAFEs", chevron: true, onClick: props.onClickActionItem }, void 0) }, void 0)] }, void 0) }, void 0));
    }
    return (_jsxs(Tile, { children: [_jsx(TileHeader, { children: "SAFEs" }, void 0),
            _jsx(TileComment, { children: "Summary of outstanding SAFEs" }, void 0),
            _jsxs(List, { children: [props.data.map(function (round) { return (_jsx(ListItem, { primary: round.name, secondary: terms(round.cap, round.discount), label: label(round.raised) }, round.id)); }),
                    _jsx(ListItem, { primary: "All SAFEs", chevron: true, onClick: props.onClickActionItem }, void 0)] }, void 0)] }, void 0));
}
//# sourceMappingURL=SafesTile.js.map